/** Customized TranslatePipe by system code String or Object from systemCodeService.codeStorage
  * Usage:
    assume codeObj = {
      code: '_CODE_1',
      code_desc_en: 'Apple',
      code_desc_tr: '蘋果',
      code_desc_zh: '苹果',
      ...   // other properties
    }
  When current language is en (English):
    {{ codeObj | translateSystemCode }} => '[_CODE_1]Apple'
    {{ codeObj.code | translateSystemCode }} => 'Apple'
*/
import { Pipe, PipeTransform, ChangeDetectorRef, Injectable, OnDestroy } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SystemCodeService } from './../service/system-code.service';

@Pipe({
  name: 'translateSystemCode',
  pure: false // required to update the value when the promise is resolved
})
export class TranslateSystemCodePipe extends TranslatePipe implements PipeTransform, OnDestroy {
  value: string = '';
  lastKey: string;
  // lastParams: any[];
  destroyed$ = new Subject<void>();

  constructor(
    private systemCodeService: SystemCodeService,
    private cdr: ChangeDetectorRef,
    translate: TranslateService,
    _ref: ChangeDetectorRef,
  ) {
    super(translate, _ref);
  }

  updateValue(key: string, interpolateParams?: Object): void {
    const onTranslation = (res: string) => {
      this.value = res !== undefined ? res : key;
      this.lastKey = key;
      this.cdr.markForCheck();
    };
    const translation = this.systemCodeService.translate(key);
    onTranslation(translation);
    this.systemCodeService.translateStream(key)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(onTranslation);
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
